import { TOOTH_BASIS_SLICE_ZOOM_CACHE_LIMIT } from '../config';
import type {
  ToothBasisSliceZoomEntry,
  ToothSliceGeometry,
  ToothSliceOptionsBySeries,
} from '../config';

import { makeToothBasisSeriesCacheKey } from './makeToothBasisSeriesCacheKey';

const entries = new Map<string, ToothBasisSliceZoomEntry>();

export const makeToothBasisSliceZoomKey = ({
  input,
  sliceOptions,
  spacingMm,
  tileID,
}: {
  input: ToothSliceGeometry;
  spacingMm: number;
  tileID: string;
  sliceOptions?: ToothSliceOptionsBySeries;
}) =>
  `zoom:${makeToothBasisSeriesCacheKey({
    input,
    sliceOptions,
    spacingOutMm: spacingMm,
  })}:${tileID}`;

export const getToothBasisSliceZoomEntry = (key: string) =>
  entries.get(key) ?? null;

export const putToothBasisSliceZoomEntry = (
  key: string,
  entry: ToothBasisSliceZoomEntry,
) => {
  const previous = entries.get(key);

  if (previous) {
    entries.delete(key);
    URL.revokeObjectURL(previous.url);
  }

  entries.set(key, entry);

  while (entries.size > TOOTH_BASIS_SLICE_ZOOM_CACHE_LIMIT) {
    const [oldestKey, oldestEntry] = [...entries][0];

    entries.delete(oldestKey);
    URL.revokeObjectURL(oldestEntry.url);
  }
};

export const clearToothBasisSliceZoomEntries = () => {
  entries.forEach((entry) => URL.revokeObjectURL(entry.url));
  entries.clear();
};
